const data = [
  {
    img: [
      "images/cars2/a43.jpg",
      "images/cars2/a44.jpg",
      "images/cars2/a45.jpg",
      "images/cars2/a46.jpg",
      "images/cars2/a41.jpg",
      "images/cars2/a42.jpg"
    ],
    title: "AUDI A4",
    transmission: "Automatic",
    fuel: "Diesel",
    price: { day: 10000, month: 95000, wd: 8000 },
  },
  {
    img: [
      "images/cars2/alto1.jpg",
      "images/cars2/alto2.jpg",
    ],
    title: "ALTO 800",
    transmission: "Manual",
    fuel: "Petrol",
    price: { day: 1000, month: '11000 - 12000' },
  },
  {
    img: [
      "images/cars2/bmw1.jpg",
      "images/cars2/bmw2.jpg",
    ],
    title: "bmw 5 series",
    transmission: "Automatic",
    fuel: "Diesel",
    price: { day: 13000, month: "1.20L", wd: 10000 },
  },
  {
    img: ["images/cars2/bmwb3.jpg", "images/cars2/bmwb1.jpg", "images/cars2/bmwb2.jpg"],
    title: "bmw 5 series Black",
    transmission: "Automatic",
    fuel: "Diesel",
    price: { day: 13000, month: "1.20L", wd: 10000 },
  },
  {
    img: ["images/cars2/bzs1.jpg", "images/cars2/bzs2.jpg", "images/cars2/bzs3.jpg"],
    title: "Mercedes Benz S class",
    transmission: "Automatic",
    fuel: "Petrol",
    price: { wd: 20000 },
  },
  {
    img: ["images/cars2/bml1.jpg"],
    title: "Mercedes Benz ML 250",
    transmission: "Manual",
    fuel: "Diesel",
    price: { wd: 15000 },
  },
  // {
  //   img: ["images/cars/bz1.jpg"],
  //   title: "Mercedez Benz E class",
  //   transmission: "Automatic",
  //   fuel: "Diesel",
  //   price: { day: 13000, month: "1.30L", wd: 10000 },
  // },
  {
    img: ["images/cars2/rr1.jpg"],
    title: "Range Rover Evoque",
    transmission: "Automatic",
    fuel: "Petrol",
    price: { wd: 16000 },
  },
  {
    img: [
      "images/cars2/ftr4.jpg",
      "images/cars2/ftr1.jpg",
      "images/cars2/ftr2.jpg",
      "images/cars2/ftr3.jpg",
    ],
    title: "Toyota Fortuner New",
    transmission: "Automatic",
    fuel: "Diesel",
    price: { day: 7500, month: 95000 },
  },
  {
    img: [
      "images/cars2/ftro1.jpg",
      "images/cars2/ftro2.jpg",
      "images/cars2/ftro3.jpg",
    ],
    title: "Toyota Fortuner Old",
    transmission: "Manual/Automatic",
    fuel: "Diesel",
    price: { day: 4000, month: 55000 },
  },
  // {
  //   img: ["images/cars2/gz1.jpg", "images/cars2/gz2.jpg"],
  //   title: "Toyota Glanza",
  //   transmission: "Automatic",
  //   fuel: "Petrol",
  //   price: { day: 1500, month: 25000 },
  // },
  {
    img: [
      "images/cars2/inv1.jpg",
    ],
    title: "Toyota Innova",
    transmission: "Manual",
    fuel: "Diesel",
    price: { day: 2000, month: 33000 },
  },
  // {
  //   img: ["images/cars2/jg1.jpg"],
  //   title: "Jaguar xf",
  //   transmission: "Automatic",
  //   fuel: "Diesel",
  //   price: { wd: 14000 },
  // },
  {
    img: [
      "images/cars2/mini1.jpg",
      "images/cars2/mini2.jpg",
    ],
    title: "Mini Cooper Covertible (Green)",
    transmission: "Manual",
    fuel: "Petrol",
    price: { day: 16000, month: "1.35L", wd: 13500 },
  },
    {
    img: [
      "images/cars2/minir1.jpg",
      "images/cars2/minir2.jpg",
      "images/cars2/mini3.jpg",
    ],
    title: "Mini Cooper Covertible (Red)",
    transmission: "Automatic",
    fuel: "Petrol",
    price: { day: 16000, month: "1.35L", wd: 13500 },
  },
  {
    img: ["images/cars2/sw2.jpg", "images/cars2/sw1.jpg","images/cars2/swr1.jpg"],
    title: "Swift New",
    transmission: "Automatic",
    fuel: "Petrol",
    price: { day: 1500, month: 25000 },
  },
  {
    img: [
      "images/cars2/thr1.jpg",
      "images/cars2/thr2.jpg",
    ],
    title: "Thar",
    transmission: "Manual",
    fuel: "Diesel",
    price: { day: 5000, month: 60000 },
  },
  {
    img: ["images/cars2/crt1.jpg"],
    title: "Hyundai Creta",
    transmission: "Manual",
    fuel: "Diesel",
    price: { day: 2000, month: 33000 },
  },
  {
    img: ["images/cars2/ub1.jpg"],
    title: "Urban Cruiser",
    transmission: "Automatic",
    fuel: "Petrol",
    price: { day: 2000, month: 35000 },
  },
  {
    img: ["images/cars2/frx1.jpg"],
    title: "Fronx",
    transmission: "Automatic",
    fuel: "Petrol",
    price: { day: 2000, month: 33000 },
  },
  // {
  //   img: [
  //     "images/cars2/mc-1.jpg",
  //     "images/cars2/mc-2.jpg",
  //     "images/cars2/mc-3.jpg",
  //   ],
  //   title: "Nissan Micra",
  //   transmission: "Manual",
  //   fuel: "Diesel",
  //   price: { day: 1500, month: 16000 },
  // },
];

export default data;